import { Alert, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { getSessionStatus, login } from "../../shared/keycloak";
export default function Sessao() {
  const [status, setStatus] = useState(getSessionStatus);
  useEffect(() => {
    const update = () => setStatus(getSessionStatus());
    window.addEventListener("esocial-session", update);
    return () => window.removeEventListener("esocial-session", update);
  }, []);
  return status.authRequired && !status.authenticated ? (
    <Alert
      severity="warning"
      sx={{ my: 2 }}
      action={
        <Button color="inherit" onClick={() => login()}>
          Entrar novamente
        </Button>
      }
    >
      Sua sessão expirou. As operações estão suspensas até uma nova
      autenticação.
    </Alert>
  ) : null;
}
